
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState('JAP');

  const handleLanguageChange = (lang: string) => {
    setCurrentLanguage(lang);
    if (lang === 'JAP') {
      i18n.changeLanguage('ja');
    } else {
      i18n.changeLanguage('en');
    }
  };

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const headerHeight = 64;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-stone-50/95 backdrop-blur-md border-b border-stone-200">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="text-black text-xl font-bold" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
              IDKnit
            </div>
          </div>
          
          <nav className="hidden md:flex items-center space-x-6">
            <a href="#home" onClick={(e) => handleNavClick(e, 'home')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Home</a>
            <a href="#about" onClick={(e) => handleNavClick(e, 'about')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Story</a>
            <a href="#portfolio" onClick={(e) => handleNavClick(e, 'portfolio')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Use Case</a>
            <a href="#services" onClick={(e) => handleNavClick(e, 'services')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Technology</a>
            <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Contact Us</a>
          </nav>
          
          <div className="flex items-center">
            <div className="flex bg-stone-100 rounded-full p-1">
              <button
                onClick={() => handleLanguageChange('JAP')}
                className={`px-2 sm:px-3 py-1 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  currentLanguage === 'JAP'
                    ? 'bg-white text-stone-700 shadow-sm'
                    : 'text-stone-600 hover:text-stone-700'
                }`}
              >
                JAP
              </button>
              <button
                onClick={() => handleLanguageChange('ENG')}
                className={`px-2 sm:px-3 py-1 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  currentLanguage === 'ENG'
                    ? 'bg-white text-stone-700 shadow-sm'
                    : 'text-stone-600 hover:text-stone-700'
                }`}
              >
                ENG
              </button>
            </div>
          </div>
          
          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ml-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-lg text-stone-600`}></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-stone-200">
            <nav className="flex flex-col space-y-3 mt-4">
              <a href="#home" onClick={(e) => handleNavClick(e, 'home')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Home</a>
              <a href="#about" onClick={(e) => handleNavClick(e, 'about')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Story</a>
              <a href="#portfolio" onClick={(e) => handleNavClick(e, 'portfolio')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Use Case</a>
              <a href="#services" onClick={(e) => handleNavClick(e, 'services')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Technology</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')} className="text-stone-600 hover:text-stone-700 transition-colors cursor-pointer text-sm">Contact Us</a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
